export function invariant<T>(
  value: T | null | undefined | false | 0 | '',
  msg?: string,
): asserts value is T {
  if (!value) {
    throw new Error(msg ?? 'Invariant failed: value must be truthy');
  }
}
